module.exports = __webpack_public_path__ + "media/images/ic_gold_medal-7c62d79d8926ac0bfe8b360cc12007c5.png";